import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../context/AuthContext";
import { BarChart3, QrCode, Brain, Users } from "lucide-react";

export default function SponsorStatsPanel({ rallyId, refreshKey }) {
  const [data, setData] = useState(null);
  useEffect(() => { axios.get(`${API}/organizer/rallies/${rallyId}/sponsors/stats`).then(r => setData(r.data)).catch(() => {}); }, [rallyId, refreshKey]);
  if (!data) return null;
  return (
    <div className="rl-card p-6 lg:col-span-2" data-testid="sponsor-stats">
      <h2 className="font-display font-bold text-xl flex items-center gap-2 mb-1"><BarChart3 className="w-5 h-5 text-[#00F0FF]" /> Statistiche sponsor</h2>
      <p className="text-xs text-slate-500 mb-4">Scansioni QR, quiz completati e coinvolgimento per ogni sponsor su {data.fans_total} fan attivi.</p>
      {data.sponsors.length === 0 && <div className="text-sm text-slate-500">Nessuna attività sponsor ancora: assegna uno sponsor a quiz e missioni.</div>}
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-3">
        {data.sponsors.map(s => (
          <div key={s.sponsor} className="border border-white/5 rounded-lg p-4" data-testid={`sponsor-stat-${s.sponsor.replace(/\s+/g, "-").toLowerCase()}`}>
            <div className="flex items-center justify-between mb-3">
              <div className="font-display font-black text-lg">{s.sponsor}</div>
              <span className="pill-badge pill-amber !py-0.5 !px-2 !text-[9px]">ENGAGEMENT {s.engagement}%</span>
            </div>
            <div className="grid grid-cols-3 gap-2 text-center mb-3">
              <div><QrCode className="w-4 h-4 mx-auto text-[#00F0FF]" /><div className="font-mono-rl font-bold text-lg">{s.qr_scans}</div><div className="text-[9px] font-mono-rl text-slate-500">SCANSIONI QR</div></div>
              <div><Brain className="w-4 h-4 mx-auto text-[#FF9F0A]" /><div className="font-mono-rl font-bold text-lg">{s.quiz_completions}</div><div className="text-[9px] font-mono-rl text-slate-500">QUIZ FATTI</div></div>
              <div><Users className="w-4 h-4 mx-auto text-[#30D158]" /><div className="font-mono-rl font-bold text-lg">{s.fans}</div><div className="text-[9px] font-mono-rl text-slate-500">FAN RAGGIUNTI</div></div>
            </div>
            <div className="h-1.5 bg-white/5 rounded-full overflow-hidden mb-2"><div className="h-full bg-[#00F0FF]" style={{ width: `${s.engagement}%` }} /></div>
            <div className="text-[10px] font-mono-rl text-slate-500">{s.quizzes} quiz · {s.missions} missioni · {s.points} pt distribuiti</div>
          </div>
        ))}
      </div>
    </div>
  );
}
